import { AppRecordAfterUpdate } from 'routes';
import { reportError } from '@xbcb/ui-utils';
import type { UsType86Entry } from '@xbcb/api-gateway-client';
import { UsFilingType } from '@xbcb/compliance-types';
import { classifyUsCustomsFiling } from 'libs/usEntryCustomsClassificationTransformers/classifyCustomsFiling';
import { message } from 'antd';
import { PATHFINDER_PHASE_2_ENABLED } from 'featureFlags';

export const afterUsType86EntryUpdate: AppRecordAfterUpdate = async ({
  updatedRecord,
  skipValidate,
}) => {
  // If validation was skipped on save we still want to check if the
  // updated record is eligible for T86 and show a message to the operator
  // letting them know that it's not eligible anymore because they may
  // need to flip the T86 entry back to USCE
  if (PATHFINDER_PHASE_2_ENABLED && skipValidate) {
    try {
      // Operations doesn't want undisclaimed ad/cvd or fees to flag entry as not eligible when saving
      const classifications = await classifyUsCustomsFiling(
        updatedRecord as UsType86Entry,
        { ignoreAdCvdAndFees: true },
      );
      if (!classifications) {
        void message.warning(
          'Shipment is not eligible for US Type86 Entry because of missing data',
        );
      } else if (
        !classifications?.some(
          (classification) =>
            classification.filingType === UsFilingType.US_TYPE86_ENTRY,
        )
      ) {
        void message.warning('Shipment is not eligible for US Type86 Entry');
      } else {
        void message.success('Shipment is eligible for US Type86 Entry');
      }
    } catch (e) {
      void message.warning('Unable to determine shipment US Type86 eligiblity');
      reportError(e);
    }
  }
};
